var map = {
	"./num1.png": 1014,
	"./num2.png": 6466,
	"./num3.png": 7020,
	"./num4.png": 7355,
	"./num5.png": 1693,
	"./num6.png": 4006,
	"./num7.png": 2499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6336;